/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  EditPaymentReferenceRequest,
  ExecutePaymentBatchRequest,
  ExecutePaymentBatchResponse,
  ExtendedPaymentDto,
  ListByIdsPayload,
  PaymentDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class AccountsPayablePaymentController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags accounts-payable-payment-controller
   * @name ListByIds
   * @request POST:/api/v1/payments/accounts-payable/list/ids
   */
  listByIds = (data: ListByIdsPayload, params: RequestParams = {}) =>
    this.http.request<PaymentDto[], any>({
      path: `/v1/payments/accounts-payable/list/ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static listByIdsPath = '/v1/payments/accounts-payable/list/ids'
  static listByIdsMethod = 'POST'
  /**
   * No description
   *
   * @tags accounts-payable-payment-controller
   * @name Execute
   * @request POST:/api/v1/payments/accounts-payable/execute/batch
   */
  execute = (data: ExecutePaymentBatchRequest, params: RequestParams = {}) =>
    this.http.request<ExecutePaymentBatchResponse, any>({
      path: `/v1/payments/accounts-payable/execute/batch`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static executePath = '/v1/payments/accounts-payable/execute/batch'
  static executeMethod = 'POST'
  /**
   * No description
   *
   * @tags accounts-payable-payment-controller
   * @name EditPaymentReference
   * @request POST:/api/v1/payments/accounts-payable/edit/payment-reference
   */
  editPaymentReference = (data: EditPaymentReferenceRequest, params: RequestParams = {}) =>
    this.http.request<PaymentDto, any>({
      path: `/v1/payments/accounts-payable/edit/payment-reference`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static editPaymentReferencePath = '/v1/payments/accounts-payable/edit/payment-reference'
  static editPaymentReferenceMethod = 'POST'
  /**
   * No description
   *
   * @tags accounts-payable-payment-controller
   * @name GetLatestByFlowTypeAndId
   * @request GET:/api/v1/payments/accounts-payable/linkedFlow/{flowType}/{flowId}/latest
   */
  getLatestByFlowTypeAndId = (
    flowType: 'TOP_UP' | 'INVOICE' | 'REIMBURSEMENT',
    flowId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ExtendedPaymentDto, any>({
      path: `/v1/payments/accounts-payable/linkedFlow/${flowType}/${flowId}/latest`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getLatestByFlowTypeAndIdPath =
    '/v1/payments/accounts-payable/linkedFlow/${flowType}/${flowId}/latest'
  static getLatestByFlowTypeAndIdMethod = 'GET'
  /**
   * No description
   *
   * @tags accounts-payable-payment-controller
   * @name GetAllByBatchId
   * @request GET:/api/v1/payments/accounts-payable/by-batch/{batchId}
   */
  getAllByBatchId = (batchId: string, params: RequestParams = {}) =>
    this.http.request<PaymentDto[], any>({
      path: `/v1/payments/accounts-payable/by-batch/${batchId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAllByBatchIdPath = '/v1/payments/accounts-payable/by-batch/${batchId}'
  static getAllByBatchIdMethod = 'GET'
}
